<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="4">
                    <ValidationProvider name="company_id" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('coop_company')">
                            <b-form-select v-model="formData.company_id" :options="companyOptions" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="event_name" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('coop_event_name')">
                            <b-form-input v-model="formData.event_name" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="event_type" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('coop_event_type')">
                            <b-form-select v-model="formData.event_type" :options="eventTypeOptions" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="3">
                    <ValidationProvider name="date" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('date')">
                            <b-form-input v-model="formData.date" type="date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="3">
                    <ValidationProvider name="start_time" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('start_time')">
                            <b-form-input v-model="formData.start_time" type="time" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="3">
                    <ValidationProvider name="end_time" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('end_time')">
                            <b-form-input v-model="formData.end_time" type="time" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="3">
                    <ValidationProvider name="quota" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('coop_quota')">
                            <b-form-input v-model="formData.quota" type="number" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="event_format" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('coop_event_format')">
                            <b-form-select v-model="formData.event_format" :options="eventFormatOptions" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('faculty')">
                        <faculty-selectbox v-model="formData.faculty_code" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('department')">
                        <department-selectbox :faculty_code="formData.faculty_code" v-model="formData.department_code" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('class')">
                        <classes-selectbox v-model="formData.class" />
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('detail')">
                        <b-form-textarea v-model="formData.detail" rows="4" />
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" :disabled="formLoading" @click="save" class="mr-2">
                    {{ $t('save') }}
                </b-button>
                <b-button variant="light" @click="$emit('cancel')">
                    {{ $t('cancel') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>
<script>
    import {ValidationObserver, ValidationProvider} from 'vee-validate';
    import FacultySelectbox from '@/components/interactive-fields/FacultySelectbox.vue';
    import DepartmentSelectbox from '@/components/interactive-fields/DepartmentSelectbox';
    import ClassesSelectbox from '@/components/interactive-fields/ClassesSelectbox';
    import CoopEventService from '@/services/CoopEventService';
    import CoopCompanyService from '@/services/CoopCompanyService';

    export default {
        components: {
            ValidationObserver,
            ValidationProvider,
            FacultySelectbox,
            DepartmentSelectbox,
            ClassesSelectbox
        },
        data() {
            return {
                formLoading: false,
                companyOptions: [],
                eventTypeOptions: [
                    {value: 'seminar', text: this.$t('coop_event_type_seminar')},
                    {value: 'workshop', text: this.$t('coop_event_type_workshop')},
                    {value: 'webinar', text: this.$t('coop_event_type_webinar')}
                ],
                eventFormatOptions: [
                    {value: 'online', text: this.$t('coop_location_type_remote')},
                    {value: 'onsite', text: this.$t('coop_location_type_onsite')},
                    {value: 'hybrid', text: this.$t('coop_location_type_hybrid')}
                ],
                formData: {
                    company_id: null,
                    event_name: null,
                    event_type: null,
                    date: null,
                    start_time: null,
                    end_time: null,
                    quota: null,
                    event_format: null,
                    faculty_code: null,
                    department_code: null,
                    class: null,
                    detail: null
                }
            };
        },
        created() {
            CoopCompanyService.getAll({params: {filter: {}, page: 1, limit: 1000}}).then((response) => {
                this.companyOptions = [{value: null, text: ''}].concat(
                    response.data.data.map((c) => ({value: c.id, text: c.name}))
                );
            });
        },
        methods: {
            async save() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (!isValid) return;

                this.formLoading = true;
                CoopEventService.store(this.formData)
                    .then((response) => {
                        this.$toast.success(this.$t(response.data.message));
                        this.$emit('actionSuccess');
                    })
                    .catch((error) => {
                        this.showErrors(error, this.$refs.formModalValidate);
                    })
                    .finally(() => {
                        this.formLoading = false;
                    });
            }
        }
    };
</script>
